import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router';
import { App } from './app.tsx';

import './main.css';

const renderApp = () => {
	const root = createRoot(document.getElementById('app-root')!);
	root.render(
		<BrowserRouter>
			<App />
		</BrowserRouter>,
	);
};

if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', renderApp);
} else {
	renderApp();
}
